var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-tag"},[_c('span',{staticClass:"dot",class:_vm.type,style:({ backgroundColor: _vm.color })}),_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }